import { Layout as LayoutV5 } from 'antd5';
import { Layout as LayoutV4 } from 'antd';
import styled from 'styled-components';

export const StyledLayoutV5 = styled(LayoutV5)`
  background: ${({ theme }) => theme.primaryBackgroundColor};

  .ant-layout-sider,
  .ant-layout-header,
  .ant-layout-footer,
  .ant-layout-content {
    background: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;

export const StyledLayoutV4 = styled(LayoutV4)`
  background: ${({ theme }) => theme.primaryBackgroundColor};

  .ant-layout-sider,
  .ant-layout-header,
  .ant-layout-footer,
  .ant-layout-content {
    background: ${({ theme }) => theme.primaryBackgroundColor};
  }
`;
